import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { User } from '@/modules/user/models/User';

export class LastApprovedOrRejectedByUser extends BaseModel {
  status?: string;
  createdAt?: number;
  user?: User;

  constructor(model: Partial<LastApprovedOrRejectedByUser> = {}) {
    super(model);

    this.status = model.status;
    this.createdAt = model.createdAt;
    this.user = User.mapModel(model.user);
  }
}
